(function () {
    'use strict';

    angular.module("imApp").factory("saftMainGroupService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3436,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3437,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
